import React from 'react'
import {Tooltip, Typography, withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import Units from './Units';
import GridBlock from 'components/GridBlock';
import Tr from 'translations/Translations';
import TextInput from 'components/TextInput';
import removeFormikListElement from 'libs/removeFormikListElement';
import getObjectValue from 'libs/getObjectValue';
import WorkableIconPreviewButton from "components/button/WorkableIconPreviewButton";
import WorkableIconEditButton from "components/button/WorkableIconEditButton";
import WorkableIconDeleteButton from 'components/button/WorkableIconDeleteButton';
import clsx from 'clsx';
import INPUT_TYPE from "constants/INPUT_TYPE";
import BooleanItems from "constants/BooleanItems";
import Select from "components/Select";
import OfferSourceTypes from "constants/OfferSourceTypes";
import {ItemTypes} from "../../constants/itemTypes";
import WorkableIconAddButton from "components/button/WorkableIconAddButton";
import itemDescriptionIcon from "images/position_item_o_min.png";
import itemVatIcon from "images/position_item_v_min.png";
import itemOfferSourceIcon from "images/position_item_i_min.png";
import itemQuantityIcon from "images/position_item_m_min.png";
import itemSeparateOfferIcon from "images/position_item_c_min.png";

const style = theme => ({
    root: {
        '&>*': {
            flexBasis: 0,

            '&:not(:first-child)': {
                marginLeft: theme.spacing(2)
            },
            '&:nth-child(2)': {
                flexGrow: 4
            },
            '&:nth-child(3)': {
                flexGrow: 2
            },
            '&:nth-child(4)': {
                flexGrow: 1
            }
        }
    },
    rootWeight: {
        '&>*': {
            '&:nth-child(5)': {
                flexGrow: 1
            },
        }
    },
    imageDiv: {
        display: 'flex'
    },
    image: {
        objectFit: 'contain',
        width: '24px',
        height: '24px',
        padding: '12px 6px 12px 6px'
    },
    emptyImage: {
        width: '36px'
    }
})

function MultiVariant(
    {
        classes,
        formikProps,
        id,
        index,
        option = false,
        handleEditItem,
        weightVisible,
        showConfirmBeforeDelete,
        optionalItemsEnabled
    }) {
    const objectPath = option ? `${id}.${index}.optionalItem` : `${id}.${index}`;
    const nameId = `${objectPath}.name`;
    const typeId = `${objectPath}.type`;
    const descriptionId = `${objectPath}.description`;
    const allowQuantityEditInOfferId = `${objectPath}.allowQuantityEditInOffer`;
    const predefinedVatId = `${objectPath}.offerVatPredefined`;
    const offerSourceTypeId = `${objectPath}.offerSourceType`;
    const weightId = `${objectPath}.weight`;
    const separateOfferId = `${objectPath}.separateOfferValueThanBaseItem`;
    const optionalItem = getObjectValue(`${objectPath}.optionalItem`, formikProps.values, null);
    const editable = getObjectValue('_editable', formikProps.values, true);
    const oneBaseItem = getObjectValue(id, formikProps.values, []).length <= 1;

    const predefinedVatValue = BooleanItems.find(bi => bi.value === getObjectValue(predefinedVatId, formikProps.values, null));
    const offerSourceTypeValue = OfferSourceTypes.find(bi => bi.value === getObjectValue(offerSourceTypeId, formikProps.values, null));
    const allowQuantityEditInOfferValue = BooleanItems.find(bi => bi.value === getObjectValue(allowQuantityEditInOfferId, formikProps.values, null));
    const separateOfferValue = BooleanItems.find(bi => bi.value === getObjectValue(separateOfferId, formikProps.values, null));

    const handleDelete = () => {
        if (option) {
            formikProps.setFieldValue(objectPath, null);
        } else if (!!optionalItem) {
            showConfirmBeforeDelete(id, index);
        } else {
            removeFormikListElement(formikProps, id, index);
        }
    }

    return (
        <GridBlock
            className={clsx(classes.root, {
                [classes.rootWeight]: weightVisible
            })}
        >
            <Typography variant='body1'>
                {option ? '-' : (index + 1)}
            </Typography>
            <TextInput
                id={nameId}
                label={Tr('name')}
                formikProps={formikProps}
                required
                multiline
                disabled
            />
            <Units
                idPrefix={objectPath}
                formikProps={formikProps}
                type={INPUT_TYPE.NUMBER_POSITIVE_AMOUNT_3}
                disabled
            />
            <Select
                label={Tr('position_type')}
                formikProps={formikProps}
                id={typeId}
                required
                disabled
                items={ItemTypes}
            />
            {weightVisible && <TextInput
                id={weightId}
                type={INPUT_TYPE.NUMBER_19}
                step="0.01"
                label={Tr('weight')}
                endAdornment={'%'}
                formikProps={formikProps}
                required
                disabled
            />}
            <div className={classes.imageDiv}>
                <Tooltip title={`${Tr('description')}: ${getObjectValue(descriptionId, formikProps.values, '--')}`}>
                    <img
                        className={classes.image}
                        src={itemDescriptionIcon}
                        alt={Tr('ezam')}
                    />
                </ Tooltip>
                <Tooltip title={`${Tr('offerVatPredefined')}: ${!!predefinedVatValue ? predefinedVatValue.label : '--'}`}>
                    <img
                        className={classes.image}
                        src={itemVatIcon}
                        alt={Tr('ezam')}
                    />
                </ Tooltip>
                <Tooltip title={`${Tr('offerSourceType_long')}: ${!!offerSourceTypeValue ? offerSourceTypeValue.label : '--'}`}>
                    <img
                        className={classes.image}
                        src={itemOfferSourceIcon}
                        alt={Tr('ezam')}
                    />
                </ Tooltip>
                <Tooltip title={`${Tr('allowQuantityEditInOffer_long')}: ${!!allowQuantityEditInOfferValue ? allowQuantityEditInOfferValue.label : '--'}`}>
                    <img
                        className={classes.image}
                        src={itemQuantityIcon}
                        alt={Tr('ezam')}
                    />
                </ Tooltip>
                {option && <Tooltip title={`${Tr('position_separateOfferValueThanBaseItem')}: ${!!separateOfferValue ? separateOfferValue.label : '--'}`}>
                    <img
                        className={classes.image}
                        src={itemSeparateOfferIcon}
                        alt={Tr('ezam')}
                    />
                </ Tooltip>}
                {!option && <div className={classes.emptyImage}></div>}
            </div>
            {editable ?
                <WorkableIconEditButton
                    onClick={() => handleEditItem(index, option)}
                />
                :
                <WorkableIconPreviewButton
                    onClick={() => handleEditItem(index, option)}
                />
            }
            <WorkableIconDeleteButton
                onClick={handleDelete}
                disabled={!editable || (!option && oneBaseItem)}
            />
            {!!optionalItemsEnabled && <WorkableIconAddButton
                tooltip={Tr('add_option')}
                onClick={() => handleEditItem(index, true)}
                disabled={!editable || option || !!optionalItem}
            />}
        </GridBlock>
    )
}

MultiVariant.propTypes = {
    classes: PropTypes.any,
}

export default withStyles(style)(MultiVariant);